import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header-bar flex justify-between" }
const _hoisted_2 = { class: "center-wrap flex justify-end" }
const _hoisted_3 = {
  key: 0,
  class: "badge-wrap dot"
}
const _hoisted_4 = {
  key: 1,
  class: "center-wrap flex justify-end"
}
const _hoisted_5 = { class: "center-wrap flex justify-end" }
const _hoisted_6 = { class: "user-avatar flex justify-center" }
const _hoisted_7 = {
  key: 1,
  class: "avatar-img flex justify-center"
}
const _hoisted_8 = { class: "username" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "balance-value" }

import { ref } from 'vue';
import { useUserStore, useAccountStore, useReddotStore } from "@/store";
import MenuPanel from '@/components/MenuPanel.vue';
import LangSelect from '@/components/LangSelect.vue';


export default {
  __name: 'HeaderBar',
  setup(__props) {

const userStore = useUserStore();
const accountStore = useAccountStore();
const redDotStore = useReddotStore();

const showMenuPanel = ref(false);

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_icon = _resolveComponent("van-icon")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$router.currentRoute.value.name === 'login' || _ctx.$router.currentRoute.value.name === 'register' || _ctx.$router.currentRoute.value.name === 'forgetPassword')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _withDirectives(_createVNode(_component_van_image, {
              class: "header-logo",
              src: require('@/assets/img/common/logo-title.png'),
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.$router.push({ name: 'game' })))
            }, null, 8, ["src"]), [
              [_directive_audio]
            ]),
            _createElementVNode("div", _hoisted_2, [
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "service-btn flex justify-center",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.$router.push({ name: 'livechat' })))
              }, [
                _createVNode(_component_SvgIcon, {
                  class: "service-icon",
                  name: "service"
                })
              ])), [
                [_directive_audio]
              ]),
              _createVNode(LangSelect)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_unref(userStore).uid)
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "menu-icon",
                  onClick: _cache[2] || (_cache[2] = $event => (showMenuPanel.value = true))
                }, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "menu-line" }, null, -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "menu-line" }, null, -1)),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "menu-line short" }, null, -1)),
                  (_unref(redDotStore).inboxUnread)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                    : _createCommentVNode("", true)
                ])), [
                  [_directive_audio]
                ])
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_van_image, {
              class: "header-logo",
              src: require('@/assets/img/common/logo-title.png'),
              onClick: _cache[3] || (_cache[3] = $event => (_ctx.$router.push({ name: 'game' })))
            }, null, 8, ["src"]), [
              [_directive_audio]
            ]),
            (!_unref(userStore).uid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                    class: "header-btn ghost",
                    onClick: _cache[4] || (_cache[4] = $event => (_ctx.$router.push({ name: 'login' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.login').toUpperCase()), 1)
                    ]),
                    _: 1
                  })), [
                    [_directive_audio]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                    class: "header-btn",
                    onClick: _cache[5] || (_cache[5] = $event => (_ctx.$router.push({ name: 'register' })))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.signup').toUpperCase()), 1)
                    ]),
                    _: 1
                  })), [
                    [_directive_audio]
                  ]),
                  _createVNode(LangSelect)
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (_unref(userStore).avatar)
                        ? (_openBlock(), _createBlock(_component_van_image, {
                            key: 0,
                            class: "avatar-img",
                            fit: "cover",
                            src: _unref(userStore).avatar
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_van_icon, { name: "contact" })
                          ]))
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(userStore).username), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_van_image, {
                          class: "currency-icon",
                          src: require('@/assets/img/common/currency.png')
                        }, null, 8, ["src"]),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$filter.outputAmount(_unref(accountStore).balance, 2)), 1)
                      ])
                    ])
                  ]),
                  _createVNode(LangSelect)
                ], 64))
          ], 64))
    ]),
    _createVNode(MenuPanel, {
      show: showMenuPanel.value,
      onOnClose: _cache[6] || (_cache[6] = $event => (showMenuPanel.value = false))
    }, null, 8, ["show"])
  ], 64))
}
}

}